import Cropper from 'cropperjs';

window.Cropper = Cropper;

import './service/fancy';
import './service/ControllerApi';
import './include/mask';
import './include/swiper';